import { CancellationFeedbackAdapters } from '../adapters';
import { CancellationReasonsApi } from '../clients';
import { ISubmitCancellationFeedbackPayload, ISubmitCancellationFeedbackResult } from '../types';

export const submitCancellationFeedback = async (
  payload: ISubmitCancellationFeedbackPayload,
): Promise<ISubmitCancellationFeedbackResult> => {
  const response = await CancellationReasonsApi.submitCancellationFeedback(payload);
  return CancellationFeedbackAdapters.toSubmitCancellationFeedbackResult(response);
};
